import { css, cx } from 'linaria' 
import { theme } from '../../Theme'
import { getBoolByPropertyName, getStringByPropertyName } from '../../Core/Util/Helpers';
import React from 'react'

const uspContentStyle = css`
   & p,
   & h1,
   & h2,
   & h3,
   & h4,
   & h5,
   & h6 {
      margin-block-start: 0em;
      margin-block-end: 0em;
      font-family: var(--font-grotesk);
      font-weight: 600;
      font-size: 0.75rem;
   }
   ${theme.above.xxxl} {
      & p,
      & h1,
      & h2,
      & h3,
      & h4,
      & h5,
      & h6 {
         font-size: 12px;
      }
   }
`;

const GeneralProductUSP = ({ productSettings, className }) => {
   const hideProductUSP = getBoolByPropertyName(productSettings?.properties, 'hideProductUSP') ?? true;
   const uspContent = getStringByPropertyName(productSettings?.properties, 'productUSPContent');

   if (hideProductUSP) return <></>;

   return (
      <div
         className={cx(className, uspContentStyle)}
         dangerouslySetInnerHTML={{ __html: uspContent }}
      />
   );
};

export default GeneralProductUSP